import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = () => {
  // Get auth state from Redux (adjust according to your store)
  const isAuthenticated = useSelector(state => state.analysisData.isAuthenticated);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Otherwise render child routes/components
  return <Outlet />;
};

export default ProtectedRoute;
